import TenderFormView from "@/app/features/tender/components/view/tender-form-view";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

export default function TenderPage() {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <div style={{ background: "#f8fafa !important" }}>
      {/* <NavPage 
      isForm={0}
      /> */}
      <div className="xs:flex xs:flex-col">
        <main className="flex w-full flex-col">
          <section className="w-full bg-primary-white p-5 rounded-md">
            <div className="flex flex-col">
              <h1 className="sm:text-2xl text-base font-semibold">
                {t("general.purchaseRequest")}
              </h1>
              <p className="mb-4 text-purple-500 text-sm sm:text-base">
                {t("general.FillFormToRequestPurchase")}
              </p>
            </div>
            <TenderFormView />
          </section>
        </main>
      </div>
    </div>
  );
}
